import {
  Alert as MUIAlert,
  styled,
  Slide,
  AlertProps as MuiAlertProps,
  IconButton,
  Link,
  Box,
} from '@mui/material';
import {AlertProps} from '../index';
import {CrossOutlined, ChevronLeft, WhiteCrossOutlined} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {Typography} from '@mui/material';
import {AiFillInfoCircle} from 'react-icons/ai';
import {colorPalette} from '@jobseeker/lotus/foundations';
const Alert = styled(MUIAlert)<any>(({theme, ...props}) => {
  const commonStyles: any = {
    borderRadius: theme.spacing(2),
    background: props.background ? props.background : colorPalette.green.A601,
  };

  if (props?.width) {
    commonStyles['width'] = props.width;
  }
  if (props.severity === 'warning') {
    commonStyles['background'] = '#FFF6DA';
    commonStyles['border'] = '1px solid #FFC048CC';
  }
  return commonStyles;
});

export default ({variant, show, container, ...props}: AlertProps) => {
  return (
    // <Slide in={show} container={container}>
    <Alert
      icon={!props.icon}
      severity="success"
      action={
        props.onClose && (
          <Box height="100%" alignItems="center" display="flex" p={0}>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={props.onClose}
            >
              <Image
                src={props.whiteCross ? WhiteCrossOutlined : CrossOutlined}
                alt={'Close Icon'}
                width={props.whiteCross ? 18 : 16}
                height={props.whiteCross ? 18 : 16}
                onClick={props.onClose}
                objectFit="cover"
                style={{cursor: 'pointer'}}
              />
            </IconButton>
          </Box>
        )
      }
      {...props}
      sx={{
        paddingLeft: props.icon ? 2 : '4px',
        ...props.sx,
      }}
    >
      {props.title && (
        <Typography
          color={'text.primary'}
          fontSize={{
            xxs: props.severity === 'warning' ? 14 : 16,
            md: props.severity === 'warning' ? 14 : 18,
          }}
          variant="subtitle1"
        >
          {props.title}
        </Typography>
      )}
      {props.children}
      {props.actionUrl && (
        <Link
          href={props.actionUrl}
          sx={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            color:
              props.severity === 'warning' ? 'text.primary' : 'primary.main',
          }}
        >
          <Typography variant="subtitle2" fontSize={12}>
            {props.actionLabel ?? 'See More'}
          </Typography>
          <Image src={ChevronLeft} width={13} height={13} alt="" />
        </Link>
      )}
    </Alert>
    // </Slide>
  );
};
